import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_2 = { class: "text-muted lead" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-1" }, null, -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_ContractDetailTable = _resolveComponent("ContractDetailTable")!
  const _component_Message = _resolveComponent("Message")!
  const _component_ContractDetailSwitchCard = _resolveComponent("ContractDetailSwitchCard")!
  const _component_ContractDetailExtendCard = _resolveComponent("ContractDetailExtendCard")!
  const _component_ContractExtendModal = _resolveComponent("ContractExtendModal")!
  const _component_ContractSwitchModal = _resolveComponent("ContractSwitchModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BackButton, {
      label: _ctx.$t('myCadac.contractDetail.button.back')
    }, null, 8, ["label"]),
    (_ctx.vm.pageTitle)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, _toDisplayString(_ctx.vm.pageTitle), 1))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("myCadac.contractDetail.contractNumber", {
				contractNumber: _ctx.vm.contract.contractId,
			})), 1),
    _hoisted_3,
    _createVNode(_component_ContractDetailTable, {
      contracts: [_ctx.vm.contract],
      vm: _ctx.vm
    }, null, 8, ["contracts", "vm"]),
    (_ctx.vm.yourProlongOptionsText)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(_ctx.vm.yourProlongOptionsText), 1))
      : _createCommentVNode("", true),
    (_ctx.canCoTerm)
      ? (_openBlock(), _createElementBlock("p", {
          key: 2,
          innerHTML: _ctx.vm.switchCoTermText
        }, null, 8, _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.canTradeIn)
      ? (_openBlock(), _createElementBlock("p", {
          key: 3,
          innerHTML: _ctx.vm.switchTradeInText
        }, null, 8, _hoisted_6))
      : _createCommentVNode("", true),
    (_ctx.vm.contract.renewMultiYearMaintenanceContractForOneYear)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 4,
          closable: false,
          severity: "warn"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("myCadac.contractDetail.message.prolongOnly12months")), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.contractStore.isExtendingContract)
      ? (_openBlock(), _createBlock(_component_ContractDetailSwitchCard, {
          key: 5,
          vm: _ctx.vm
        }, null, 8, ["vm"]))
      : (_openBlock(), _createBlock(_component_ContractDetailExtendCard, {
          key: 6,
          "prolongation-options": _ctx.contractStore.prolongationOptions,
          vm: _ctx.vm
        }, null, 8, ["prolongation-options", "vm"])),
    (_ctx.contractStore.isExtendModalVisible)
      ? (_openBlock(), _createBlock(_component_ContractExtendModal, {
          key: 7,
          "prolongation-options": _ctx.contractStore.prolongationOptions,
          vm: _ctx.vm,
          onCancelExtend: _ctx.onExtendCancelled,
          onConfirmExtend: _ctx.onExtendConfirmed
        }, null, 8, ["prolongation-options", "vm", "onCancelExtend", "onConfirmExtend"]))
      : _createCommentVNode("", true),
    (_ctx.contractStore.isTradeInModalVisible)
      ? (_openBlock(), _createBlock(_component_ContractSwitchModal, {
          key: 8,
          "contract-line": _ctx.contractStore.selectedTradeInContractLine,
          vm: _ctx.vm,
          onCancelTradeIn: _ctx.onTradeInCancelled,
          onConfirmTradeIn: _ctx.onTradeInConfirmed
        }, null, 8, ["contract-line", "vm", "onCancelTradeIn", "onConfirmTradeIn"]))
      : _createCommentVNode("", true)
  ], 64))
}